import React from "react";

export default function AboutUs() {
  return (
    <div className="min-h-screen bg-black text-gray-100 font-sans">
      <div className="container mx-auto px-6 py-16 max-w-4xl">
        <div className="border-l-4 border-teal-400 pl-6 mb-12">
          <h1 className="text-4xl font-bold text-white mb-3">Über uns</h1>
          <p className="text-gray-400 italic">Tradition trifft Innovation seit 1920</p>
        </div>

        <div className="grid md:grid-cols-3 gap-10">
          {/* Main content */}
          <div className="md:col-span-2 space-y-6">
            <div className="bg-gray-900 bg-opacity-50 rounded-lg p-8 shadow-xl">
              <h2 className="text-2xl font-semibold text-teal-400 mb-6">Ein Jahrhundert Erfahrung</h2>
              
              <p className="text-lg leading-relaxed mb-6">
                Seit über <span className="text-teal-300 font-medium">100 Jahren</span> werden in Heidenau Ausrüstungen für die Bohrindustrie gefertigt. 
                Dabei ist es gelungen, über die unterschiedlichsten Firmen hinweg, die Erfahrungen zu bewahren und auszubauen.
              </p>
              
              <p className="text-lg leading-relaxed mb-6">
                Mit der Neugründung der Firma <span className="text-white font-medium">G-A-B-S GmbH</span> in Heidenau bei Dresden im Jahr 2004 
                wurde es ermöglicht, auf der Basis einer bewährten, eingearbeiteten Stammmannschaft diese Fertigkeiten in eine neue Zukunft zu tragen.
              </p>
              
              <h2 className="text-xl font-semibold text-teal-400 mt-10 mb-6">Unsere Leistungen</h2>
              
              <p className="text-lg leading-relaxed mb-4">
                Unser Unternehmen bietet Ihnen heute zuverlässige Leistungen in folgenden Branchen:
              </p>
              
              <ul className="space-y-4 my-6 ml-4">
                <li className="flex items-start">
                  <span className="text-teal-400 mr-3 mt-1">•</span>
                  <span className="text-lg leading-relaxed font-medium">Entwicklung, Fertigung und Vertrieb von Bohrausrüstungen</span>
                </li>
                <li className="flex items-start">
                  <span className="text-teal-400 mr-3 mt-1">•</span>
                  <span className="text-lg leading-relaxed">Mechanische Fertigung von Maschinenbauteilen bzw. kleinen Baugruppen nach Zeichnungen oder Muster; konstruktive Beratung und Weiterentwicklungen sind möglich</span>
                </li>
                <li className="flex items-start">
                  <span className="text-teal-400 mr-3 mt-1">•</span>
                  <span className="text-lg leading-relaxed font-medium">Horizontalbohrungen / Durchörterungen</span>
                </li>
              </ul>
              
              <p className="text-lg leading-relaxed mt-8 italic">
                Eine kurzfristige, qualitäts- und termingerechte Umsetzung Ihrer Wünsche sind unser täglicher Ansporn.
              </p>
              
              <div className="mt-10 pt-6 border-t border-gray-700">
                <p className="text-xl font-medium text-white">
                  Wir wären erfreut, auch Sie zu unseren Kunden zählen zu dürfen.
                </p>
                <p className="text-lg text-gray-300 mt-2">
                  Für Ihre Anfragen stehen wir Ihnen jederzeit zur Verfügung.
                </p>
              </div>
            </div>
          </div>
          
          {/* Side content */}
          <div className="space-y-6">
            <div className="bg-gray-900 bg-opacity-50 rounded-lg p-6 shadow-lg">
              <h3 className="text-xl font-semibold text-teal-400 mb-4">Unser Standort</h3>
              <p className="text-gray-300">Heidenau bei Dresden</p>
              <p className="text-gray-400 mt-2">Sachsen, Deutschland</p>
              <div className="mt-4 pt-4 border-t border-gray-800">
                <p className="text-gray-300">
                  <span className="text-teal-400 mr-2">✓</span>
                  Zentrale Lage in Sachsen
                </p>
                <p className="text-gray-300 mt-2">
                  <span className="text-teal-400 mr-2">✓</span>
                  Exzellente Verkehrsanbindung
                </p>
              </div>
            </div>

            <div className="bg-gray-900 bg-opacity-50 rounded-lg p-6 shadow-lg">
              <h3 className="text-xl font-semibold text-teal-400 mb-4">Auslieferungslager mit Spezialprodukten in</h3>
              <div className="mt-4 pt-4 border-t border-gray-800">
              <p className="text-gray-300">
                  <span className="text-teal-400 mr-2">✓</span>
                  Heikendorf bei Kiel

                </p>
                <p className="text-gray-300">
                  <span className="text-teal-400 mr-2">✓</span>
                  ⁠Berlin Pankow

                </p>
                <p className="text-gray-300 mt-2">
                  <span className="text-teal-400 mr-2">✓</span>
                     Hannover Isernhagen
                </p>
              </div>
            </div>
            
            <div className="bg-gray-900 bg-opacity-50 rounded-lg p-6 shadow-lg">
              <h3 className="text-xl font-semibold text-teal-400 mb-4">Unsere Mission</h3>
              <p className="text-gray-300 leading-relaxed">
                Wir verbinden traditionelles Handwerk mit modernen Fertigungstechniken, 
                um innovative Lösungen und erstklassigen Service zu bieten und unsere 
                Kunden in jeder Phase ihres Projektes zu unterstützen.
              </p>
            </div>
            
            <div className="bg-gray-900 bg-opacity-50 rounded-lg p-6 shadow-lg">
              <h3 className="text-xl font-semibold text-teal-400 mb-4">Zertifizierungen</h3>
              <ul className="space-y-2 text-gray-300">
                <li className="flex items-center">
                  <span className="text-teal-400 mr-2">✓</span>
                  ISO 9001:2015
                </li>
                <li className="flex items-center">
                  <span className="text-teal-400 mr-2">✓</span>
                  TÜV-geprüfte Qualität
                </li>
                <li className="flex items-center">
                  <span className="text-teal-400 mr-2">✓</span>
                  Zertifizierter Fachbetrieb
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-800 text-gray-500 text-sm">
          <p>© {new Date().getFullYear()} G-A-B-S GmbH. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </div>
  );
}